// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__337LW","colBig":"styles_colBig__2iS6G","colSmall":"styles_colSmall__3sEVb","shopifyNameWrapper":"styles_shopifyNameWrapper__Ewx08"};